import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaRadiation } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./MenuLateral.css";

import NuclearExplosion from "./NuclearExplosion";
import FormBuilder from "../Inscripciones/FormBuilder";
import DynamicForm from "../Inscripciones/DynamicForm";
import axios from "axios";
import ListadoInscripciones from "../Inscripciones/ListadoInscripciones";
import ProcesosBuilder from "../Inscripciones/ProcesosBuilder";
import CargarExcelConsulta from "../modulos/CargarExcelConsulta";
import ImportarEscalafonPolicia from "./ImportarEscalafonPolicia ";
import ImportarCalificacionesInspector from "./ImportarCalificacionesInspector";
import ImportarNotasMoodleSIGEDI from "../Calificaciones/ImportarNotasMoodleSIGEDI";
import Swal from "sweetalert2";
import GrabadorVideoEntrevista from "./GrabadorVideoEntrevista";
import ReproductorVideoEntrevista from "./VideoReproductorEntrevista";
import CalificarMasivoPorInstancia from "./CalificarMasivoPorInstancia";
import DescargarPostulacionesZip from "../Inscripciones/DescargarPostulacionesZip";
import ModuloAvisosAusenciasDocentes from "../Docentes/ModuloAvisosAusenciasDocentes";
import ModuloSanidadAusenciasDocentes from "../Sanidad/ModuloSanidadAusenciasDocentes";
import EditorMail from "../EditorHtml/EditorMail";
import ModuloPermisos from "../Permisos/ModuloPermisos";
const API = "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";

const MenuLateral = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [seleccion, setSeleccion] = useState("Alertas");
  const [inscripciones, setInscripciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formSeleccionado, setFormSeleccionado] = useState(null);
  const [formLectura, setFormLectura] = useState(null);
  const [personaSeleccionada, setPersonaSeleccionada] = useState(null);
  const [boom, setBoom] = useState(false);

  const navigate = useNavigate();





useEffect(() => {
    const usuario = localStorage.getItem("usuarioSIGEDI");

    if (!usuario) {
        navigate("/usuarioLogueado");
        return;
    }

    try {
        const datos = JSON.parse(usuario);
        const obtieneDependenciaID = Number(datos.destino);

        console.log("Dependencia ID:", obtieneDependenciaID);

        if (obtieneDependenciaID !== 7) {
            navigate("/usuarioLogueado");
        }

    } catch (error) {
        console.error("Error al parsear usuarioSIGEDI:", error);
        navigate("/usuarioLogueado");
    }
}, [navigate]);
  

  const toggleMenu = () => setIsOpen(!isOpen);

  const personas = {
    nombre: "Luis",
    apellido: "Pereyra",
    dni: "31419833",
    fecha_nacimiento: "1984-01-01",
    email: "neotheoldone@gmail.com",
    celular_personal: "3413361678",
  };

  const instancia = {
    nombre: "Examen Integrador Academico",
    nombreCurso: "prueba con plataforma",
    id: "92",
  };

  const normalizarBool = (valor) => {
    return (
      valor === true ||
      valor === 1 ||
      valor === "1" ||
      valor === "true"
    );
  };

  const normalizarFechaInput = (fecha) => {
    if (!fecha) return "";

    if (
      typeof fecha === "string" &&
      /^\d{4}-\d{2}-\d{2}$/.test(fecha)
    ) {
      return fecha;
    }

    if (typeof fecha === "string" && fecha.includes("T")) {
      return fecha.split("T")[0];
    }

    const d = new Date(fecha);

    if (Number.isNaN(d.getTime())) return "";

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const mostrarFecha = (fecha) => {
    const normalizada = normalizarFechaInput(fecha);

    if (!normalizada) return "Sin fecha";

    const [anio, mes, dia] = normalizada.split("-");

    return `${dia}/${mes}/${anio}`;
  };

  const cargarFormularios = async () => {
    try {
      setLoading(true);

      const res = await axios.post(`${API}/obtenerFormulariosActivos`);

      const hoy = new Date();

      const conEstado = res.data.map((f) => {
        const fechaInicio = normalizarFechaInput(f.fechaInicio);
        const fechaFinalizacion = normalizarFechaInput(
          f.fechaFinalizacion
        );

        const inicio = fechaInicio
          ? new Date(`${fechaInicio}T00:00:00`)
          : null;

        const fin = fechaFinalizacion
          ? new Date(`${fechaFinalizacion}T23:59:59`)
          : null;

        let estado = "cerrada";

        if (inicio && fin) {
          if (hoy >= inicio && hoy <= fin) {
            estado = "abierta";
          } else if (hoy < inicio) {
            estado = "proxima";
          } else if (hoy > fin) {
            estado = "finalizada";
          }
        }

        return {
          ...f,
          fechaInicio,
          fechaFinalizacion,
          restringeFormulario: normalizarBool(f.restringeFormulario),
          estado,
        };
      });

      setInscripciones(conEstado);
    } catch (error) {
      console.error("Error cargando inscripciones", error);

      Swal.fire(
        "Error",
        "No se pudieron cargar los formularios",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarFormularios();
  }, []);

  const clonarFormulario = async (formulario) => {
    const result = await Swal.fire({
      title: "¿Clonar formulario?",
      html: `
        Se creará una copia completa de:<br/>
        <b>${formulario.nombre}</b><br/>
        ID original: <b>${formulario.id}</b>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, clonar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      Swal.fire({
        title: "Clonando formulario...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await axios.post(`${API}/clonarFormulario/${formulario.id}`);

      await cargarFormularios();

      Swal.fire(
        "Correcto",
        "Formulario clonado correctamente",
        "success"
      );
    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
        error?.response?.data?.mensaje ||
        "No se pudo clonar el formulario",
        "error"
      );
    }
  };

  const volverAListaFormularios = async () => {
    setFormSeleccionado(null);
    await cargarFormularios();
  };

  const opcionesMenu = [
    "Form builder Pro",
    "Lectores",
    "Procesos Builder",
    "Calificar Por instancia",
    "Genera zip",
    "Conchas",
    "Emails",
    "ImportaEscalafones",
    "Corrige intentos",
    "estlo",
    "SelectorDireccion",
    "Grabador", "Modulo Avisos Ausencias Docentes", "Modulo Sanidad Ausencias Docentes",
    "Gestionar Permisos",

  ];

  const renderListadoFormularios = () => {
    return (
      <div>
        <h3>📋 Formularios disponibles</h3>

        <button onClick={() => setFormSeleccionado("nuevo")}>
          ➕ Crear nuevo formulario
        </button>

        <button
          onClick={cargarFormularios}
          style={{ marginLeft: 8 }}
        >
          🔄 Recargar
        </button>

        {inscripciones.length === 0 && <p>No hay formularios</p>}

        <ul style={{ paddingLeft: 0, listStyle: "none" }}>
          {inscripciones.map((f) => (
            <li
              key={f.id}
              style={{
                marginBottom: "12px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: 8,
                background: "#fff",
              }}
            >
              <strong>{f.nombre}</strong>
              <br />

              <span>ID: {f.id}</span>
              <br />

              <span>Estado: {f.estado}</span>
              <br />

              <span>
                Apertura: {mostrarFecha(f.fechaInicio)}
              </span>
              <br />

              <span>
                Cierre: {mostrarFecha(f.fechaFinalizacion)}
              </span>
              <br />

              <span>
                Restringe formulario:{" "}
                <b>
                  {f.restringeFormulario ? "Sí" : "No"}
                </b>
              </span>
              <br />

              <span>
                Escuela: {f.escuela || "Sin escuela"}
              </span>
              <br />

              <span>
                Restricciones: {f.restricciones || "Sin restricciones"}
              </span>

              <div
                style={{
                  display: "flex",
                  gap: 8,
                  marginTop: 8,
                  flexWrap: "wrap",
                }}
              >
                <button onClick={() => setFormSeleccionado(f)}>
                  ✏️ Editar
                </button>

                <button onClick={() => clonarFormulario(f)}>
                  📋 Clonar
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const renderComponent = () => {
    switch (seleccion) {
      case "Lectores":
        if (loading) return <div>Cargando formularios...</div>;

        if (formLectura && personaSeleccionada) {
          return (
            <div>
              <button
                onClick={() => {
                  setFormLectura(null);
                  setPersonaSeleccionada(null);
                }}
              >
                ⬅ Volver
              </button>

              <DynamicForm
                formularioId={formLectura.id}
                persona={personaSeleccionada}
              />
            </div>
          );
        }

        if (formLectura) {
          return (
            <div>
              <button onClick={() => setFormLectura(null)}>
                ⬅ Volver a formularios
              </button>

              {formLectura?.id && (
                <ListadoInscripciones
                  formulario_id={formLectura}
                  turnos={true}
                />
              )}

              <h3>👤 Seleccionar persona</h3>

              <button onClick={() => setPersonaSeleccionada(personas)}>
                Luis Pereyra
              </button>

              <input
                placeholder="DNI"
                onBlur={(e) => {
                  setPersonaSeleccionada({
                    ...personas,
                    dni: e.target.value,
                  });
                }}
              />
            </div>
          );
        }

        return (
          <div>
            <h3>📋 Seleccionar formulario</h3>

            {inscripciones.length === 0 && <p>No hay formularios</p>}

            {inscripciones.map((f) => (
              <div
                key={f.id}
                style={{
                  marginBottom: "10px",
                  padding: 10,
                  border: "1px solid #ddd",
                  borderRadius: 8,
                }}
              >
                <strong>{f.nombre}</strong> - {f.estado}
                <br />
                ID: {f.id}
                <br />
                Apertura: {mostrarFecha(f.fechaInicio)}
                <br />
                Cierre: {mostrarFecha(f.fechaFinalizacion)}
                <br />
                Restringe: {f.restringeFormulario ? "Sí" : "No"}
                <br />

                <button onClick={() => setFormLectura(f)}>
                  Usar
                </button>
              </div>
            ))}
          </div>
        );

      case "Procesos Builder":
        return (
          <div>
           
           
            <ProcesosBuilder />

            <NuclearExplosion show={boom} />
          </div>
        );

      case "Form builder Pro":
        if (loading) return <div>Cargando formularios...</div>;

        if (formSeleccionado === "nuevo") {
          return (
            <div>
              <button onClick={volverAListaFormularios}>
                ⬅ Volver a lista
              </button>

              <FormBuilder />
            </div>
          );
        }

        if (formSeleccionado) {
          return (
            <div>
              <button onClick={volverAListaFormularios}>
                ⬅ Volver a lista
              </button>

              <div
                style={{
                  margin: "10px 0",
                  padding: 10,
                  background: "#f8f9fa",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                }}
              >
                <b>Editando formulario:</b> {formSeleccionado.nombre}
                <br />
                ID: {formSeleccionado.id}
                <br />
                Apertura: {mostrarFecha(formSeleccionado.fechaInicio)}
                <br />
                Cierre: {mostrarFecha(formSeleccionado.fechaFinalizacion)}
                <br />
                Restringe formulario:{" "}
                {formSeleccionado.restringeFormulario ? "Sí" : "No"}
              </div>

              <FormBuilder formularioId={formSeleccionado.id} />
            </div>
          );
        }

        return renderListadoFormularios();

      case "Calificar Por instancia":
        return <CalificarMasivoPorInstancia />;


      case "Emails":
        return <EditorMail />;

      case "SelectorDireccion":
        return (
          <ReproductorVideoEntrevista
            dni={30548471}
            procesoId={6}
            itemId={62}
          />
        );

      case "Grabador":
        return (
          <GrabadorVideoEntrevista
            dni={30548471}
            procesoId={6}
            itemId={62}
            onVideoSubido={(data) => {
              //               console.log("Video subido:", data);
            }}
          />
        );

      case "Conchas":
        return <CargarExcelConsulta />;

      case "Genera zip":
        return <DescargarPostulacionesZip formularioId={21} />;

      case "ImportaEscalafones":
        return <ImportarEscalafonPolicia />;

      case "estlo":
        return <ImportarNotasMoodleSIGEDI instancia={instancia} />;

      case "Modulo Avisos Ausencias Docentes":
        return <ModuloAvisosAusenciasDocentes />;
      case "Modulo Sanidad Ausencias Docentes":
        return <ModuloSanidadAusenciasDocentes />;
      case "Gestionar Permisos":
        return <ModuloPermisos />;
        
      default:
        return renderListadoFormularios();
    }
  };

  return (
    <div className="ml-container">
      <div className="ml-hamburger-btn">
        <button onClick={toggleMenu}>
          {isOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
        </button>
      </div>

      <nav
        className={`ml-sidebar ${isOpen ? "ml-open" : ""}`}
        style={{
          overflowY: "auto",
          maxHeight: "100vh",
        }}
      >
        <div className="ml-logo">
          <FaRadiation size={50} className="ml-icon-nuclear" />
          <h2>Tecnología y Desarrollo</h2>
        </div>

        <ul
          className="ml-menu-list"
          style={{
            maxHeight: "calc(100vh - 140px)",
            overflowY: "auto",
            paddingBottom: 30,
          }}
        >
          {opcionesMenu.map((item) => (
            <li key={item}>
              <button
                className={`ml-menu-btn ${seleccion === item ? "ml-selected" : ""
                  }`}
                onClick={() => {
                  setSeleccion(item);
                  setFormSeleccionado(null);
                  setFormLectura(null);
                  setPersonaSeleccionada(null);

                  if (window.innerWidth < 768) {
                    setIsOpen(false);
                  }
                }}
              >
                {item}
              </button>
            </li>
          ))}

          <li>
            <button
              className="ml-volver-btn"
              onClick={() => navigate("/usuarioLogueado")}
            >
              ⬅ Volver
            </button>
          </li>
        </ul>
      </nav>

      <main className="ml-content">{renderComponent()}</main>
    </div>
  );
};

export default MenuLateral;